<template>
	<div class="content-wrapper" :style="cssVariables">
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: 'colored-content-block',
	props: {
		bgColor: String,
		textColor: {
			type: String,
			default: '#fff'
		},
		fontSize: {
			type: Number,
			default: 16
		},
		textAlign: String
	},
	computed: {
		cssVariables() {
			return {
				'--bg-color': this.bgColor,
				'--text-color': this.textColor,
				'--font-size': `${this.fontSize}px`,
				'--text-align': this.textAlign
			}
		}
	}
}
</script>
<style lang="postcss" scoped>
	.content-wrapper {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 1.5rem;
		background-color: var(--bg-color);
		color: var(--text-color);
		font-size: var(--font-size);
		text-align: var(--text-align);
	}
</style>